import { configureCreativePreferences } from '@egreact/shared';
import { get_logo, getAPIUrl, getAuthToken, isAdmin } from '../../script/util';

// This app's own API base and auth header. Imported for the side effect, so
// the form is configured before either page renders.
configureCreativePreferences({
  getAPIUrl,
  getAuthToken,
  isAdmin,
  logoSrc: get_logo(true),
});
